import banner from "../../../courses/module-2/img3.png";

const modulo3 = {
  courseId: "cripto-blockchain",
  id: "modulo-3",
  title:
    "🧩 MÓDULO 3: Bitcoin, Ethereum, Solana, Cardano, Polygon y Stellar – Las Grandes Ligas del Cripto",
  estimatedDuration: "1 hora 30 minutos",
  format: "Lectura + actividad de verificación",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivo del módulo",
      content: [
        "Conocer las características, diferencias y usos principales de seis blockchains líderes en el mundo cripto, entendiendo para qué sirve cada una, cómo funciona y por qué es importante no confundir las redes al momento de operar.",
      ],
    },
    {
      id: "por-que",
      navLabel: "¿Por qué tantas?",
      title: "🌍 ¿Por qué existen tantas blockchains?",
      content: [
        {
          type: "paragraph",
          text: "Cada blockchain fue creada con un propósito diferente: unas priorizan la velocidad, otras la seguridad, otras la inclusión financiera o el desarrollo de aplicaciones.",
        },
        {
          type: "paragraph",
          text: "Por eso, es fundamental conocer cuál red es más adecuada para cada situación.",
        },
      ],
    },
    {
      id: "bitcoin",
      navLabel: "Bitcoin (BTC)",
      title: "🔹 Bitcoin (BTC): el pionero y el “oro digital”",
      content: [
        {
          type: "paragraph",
          text: "¿Qué es? La primera criptomoneda, creada en 2009 para permitir pagos sin bancos.",
        },
        {
          type: "paragraph",
          text: "Uso principal: Almacenar valor (como si fuera oro digital) y enviar pagos simples.",
        },
        {
          type: "paragraph",
          text: "Dato extra: Es la red más segura, pero también la más lenta y costosa.",
        },
      ],
    },
    {
      id: "ethereum",
      navLabel: "Ethereum (ETH)",
      title: "🔹 Ethereum (ETH): la base del mundo Web3",
      content: [
        {
          type: "paragraph",
          text: "¿Qué es? Una blockchain que permite crear aplicaciones descentralizadas (dApps) y contratos inteligentes (smart contracts).",
        },
        {
          type: "paragraph",
          text: "Uso principal: Finanzas descentralizadas (DeFi), NFT, DAOs y mucho más.",
        },
        {
          type: "paragraph",
          text: "Dato extra: Pasó a usar un sistema más ecológico en 2022 llamado Proof of Stake.",
        },
        {
          type: "table",
          headers: ["Concepto", "¿Qué es?", "¿Para qué sirve?", "Ejemplo real"],
          rows: [
            [
              "DeFi",
              "Finanzas sin bancos",
              "Prestar, ahorrar, invertir cripto",
              "App que te paga intereses",
            ],
            [
              "NFT",
              "Objeto digital único",
              "Arte, música, entradas, coleccionables",
              "Álbum NFT exclusivo",
            ],
            [
              "DAO",
              "Comunidad digital sin jefes",
              "Votar, organizarse, invertir en grupo",
              "Fondo de arte gestionado por votación",
            ],
          ],
        },
      ],
    },
    {
      id: "solana",
      navLabel: "Solana (SOL)",
      title: "🔹 Solana (SOL): rapidez para juegos y NFTs",
      content: [
        {
          type: "paragraph",
          text: "¿Qué es? Una blockchain enfocada en la velocidad y en tarifas muy bajas.",
        },
        {
          type: "paragraph",
          text: "Uso principal: Juegos Web3, mercados de NFTs, apps móviles.",
        },
        {
          type: "paragraph",
          text: "Dato extra: Ha tenido interrupciones técnicas, pero su comunidad sigue creciendo.",
        },
      ],
    },
    {
      id: "cardano",
      navLabel: "Cardano (ADA)",
      title: "🔹 Cardano (ADA): sostenibilidad e inclusión",
      content: [
        {
          type: "paragraph",
          text: "¿Qué es? Una blockchain basada en estudios académicos y revisión científica.",
        },
        {
          type: "paragraph",
          text: "Uso principal: Proyectos sociales, votaciones digitales y contratos inteligentes.",
        },
        {
          type: "paragraph",
          text: "Dato extra: Trabaja con gobiernos africanos para registrar datos educativos.",
        },
      ],
    },
    {
      id: "polygon",
      navLabel: "Polygon (MATIC)",
      title: "🔹 Polygon (MATIC): acelerando a Ethereum",
      content: [
        {
          type: "paragraph",
          text: "¿Qué es? Una solución que se conecta a Ethereum para hacerla más rápida y barata.",
        },
        {
          type: "paragraph",
          text: "Uso principal: Desarrollar apps, programas de fidelidad, coleccionables digitales.",
        },
        {
          type: "paragraph",
          text: "Dato extra: Usada por grandes marcas como Disney, Meta, Adidas y Reddit.",
        },
      ],
    },
    {
      id: "stellar",
      navLabel: "Stellar (XLM)",
      title: "🔹 Stellar (XLM): pagos internacionales rápidos y simples",
      content: [
        {
          type: "paragraph",
          text: "¿Qué es? Una blockchain pensada para transferencias globales rápidas y con bajos costos.",
        },
        {
          type: "paragraph",
          text: "Uso principal: Enviar dinero entre países, convertir monedas locales, trabajar con ONGs.",
        },
        {
          type: "paragraph",
          text: "Dato extra: Tiene alianzas con Visa, IBM, MoneyGram y la ONU.",
        },
      ],
    },
    {
      id: "videos",
      navLabel: "Videos",
      title: "📺 Videos recomendados",
      content: [
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=dsTDTa1aP7M",
          text: "🎥 ¿Qué es Bitcoin y cómo funciona?",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=36t2S6NeUgU",
          text: "🎥 ¿Qué es Ethereum?",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=HzF6kyS3Fb8",
          text: "🎥 Solana vs Ethereum: ¿Cuál es mejor?",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=ACD2qlb76OgM",
          text: "🎥 ¿Qué es Cardano?",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=AfyudjDyp3U",
          text: "🎥 Polygon explicado fácil",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=ectLrWsYGgs",
          text: "🎥 ¿Qué es Stellar (XLM)?",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Actividad",
      title: "📊 Actividad del módulo",
      content: [
        "Completa una tabla comparativa entre las 6 redes estudiadas. Puedes usar Google Docs, Canva, Notion o papel.",
        {
          type: "table",
          headers: [
            "Red",
            "¿Para qué se usa?",
            "Velocidad aprox. (TPS)",
            "Seguridad",
            "Comunidad / Proyectos destacados",
          ],
          rows: [
            ["Bitcoin", "", "", "", ""],
            ["Ethereum", "", "", "", ""],
            ["Solana", "", "", "", ""],
            ["Cardano", "", "", "", ""],
            ["Polygon", "", "", "", ""],
            ["Stellar", "", "", "", ""],
          ],
        },
      ],
    },
    {
      id: "nota",
      navLabel: "Nota Impotante",
      title:
        "⚠️ NOTA IMPORTANTE – No confundas la red, el token, la abreviatura y la criptomoneda",
      content: [
        {
          type: "paragraph",
          text: "En el mundo cripto, hay términos que suenan parecidos pero no significan lo mismo. Entenderlos puede evitar que pierdas dinero por error.",
        },
        {
          type: "paragraph",
          text: "🧩 ¿Cuál es la diferencia?",
        },
        {
          type: "table",
          headers: ["Término", "¿Qué es?", "Ejemplo"],
          rows: [
            [
              "Criptomoneda",
              "Es el activo digital en sí. Como una moneda virtual con valor.",
              "USDC, BTC, ETH",
            ],
            [
              "Token",
              "Es un tipo de criptomoneda creada sobre una blockchain ya existente.",
              "USDC es un token en Ethereum, Polygon, Solana...",
            ],
            [
              "Red (blockchain)",
              "Es la infraestructura donde viven las criptos. Cada red tiene sus propias reglas.",
              "Ethereum, Solana, Stellar",
            ],
            [
              "Abreviatura",
              "Son las siglas que representan una cripto en las plataformas.",
              "BTC = Bitcoin, ETH = Ethereum, XLM = Stellar",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "🔄 Un mismo token puede vivir en varias redes",
        },
        {
          type: "paragraph",
          text: "Por ejemplo, USDC existe en Ethereum, Polygon, Solana y Stellar. Pero NO es el mismo USDC técnicamente en cada red. Si envías USDC por una red incorrecta, el receptor podría no recibir nada.",
        },
        {
          type: "paragraph",
          text: "⚠️ ¿Qué pasa si te equivocas de red?",
        },
        {
          type: "list",
          items: [
            "Podrías perder tus fondos para siempre",
            "No siempre es posible “revertir” una transferencia cripto",
          ],
        },
        {
          type: "paragraph",
          text: "Por eso, antes de enviar, verifica todo:",
        },
        {
          type: "orderedList",
          items: [
            "La red correcta (Ethereum, Solana, etc.)",
            "La dirección del receptor (debe ser compatible con la red y el token)",
            "El token correcto (por ejemplo, USDT en Polygon ≠ USDT en Ethereum)",
          ],
        },
        {
          type: "paragraph",
          text: "🧠 En Web3, no hay botón de “cancelar” ni servicio al cliente que pueda recuperar fondos perdidos por error. Tú eres el custodio.",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Frase del día",
      title: "🧠 Frase del día",
      content: [
        "No se trata de cuál blockchain es mejor, sino de cuál resuelve mejor un problema real.",
      ],
    },
  ],
};

export default modulo3;
